import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import AccentBar from "./AccentBar";
const Surtitle = (props) => {
    const { title, contrast = false, withRightBand = false, component = "h2", } = props;
    return (_jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: "center" }, children: [_jsx(AccentBar, {}), _jsx(Typography, { variant: "body2", component: component, sx: {
                    color: contrast ? "primary.contrastText" : undefined,
                    textTransform: "uppercase",
                    letterSpacing: "10%",
                    fontSize: { xs: "12px", md: "14px" },
                }, children: title }), withRightBand && _jsx(AccentBar, {})] }));
};
export default Surtitle;
